import { GraphQLResult } from '@aws-amplify/api';
import {
  CreateEngineerMutation,
  EngineerInput,
  EngineerPhase,
  Experience,
  GetEngineerQuery,
  S3Object,
  UpdateEngineerInput,
  UpdateEngineerMutation,
  UrchinTrackingModule,
} from '../API';
import callGraphQL from '../graphql-wrapper';
import { createEngineer, updateEngineer } from '../graphql/mutations';
import { getEngineer } from '../graphql/queries';

export interface Engineer {
  id: string,
  owner: string,
  experience?: Experience,
  skillIds: string[],
  cv?: S3Object,
  linkedIn?: string,
  phase?: EngineerPhase,
  utm?: UrchinTrackingModule,
  createdAt: string,
  updatedAt: string,
}

export const EXPERIENCE_HUMAN_NAMES = {
  [Experience.FROM_0_TO_2]: '0 to 2 years',
  [Experience.FROM_2_TO_3]: '2 to 3 years',
  [Experience.FROM_3_TO_5]: '3 to 5 years',
  [Experience.FROM_5_TO_10]: '5 to 10 years',
  [Experience.FROM_10_AND_MORE]: '10+ years',
};

function mapEngineerQuery(result: GraphQLResult<GetEngineerQuery>) {
  return result.data?.getEngineer as Engineer;
}

function fetchEngineer(id: string) {
  return callGraphQL<GetEngineerQuery>(
    getEngineer,
    { variables: { id } },
  ).then(mapEngineerQuery);
}

function mapEngineerCreation(result: GraphQLResult<CreateEngineerMutation>) {
  return result.data?.createEngineer as Engineer;
}

function createEngineerWrapper(input: EngineerInput) {
  return callGraphQL<CreateEngineerMutation>(createEngineer, {
    variables: { input },
  }).then(mapEngineerCreation);
}

function mapEngineerUpdate(result: GraphQLResult<UpdateEngineerMutation>) {
  return result.data?.updateEngineer as Engineer;
}

function updateEngineerWrapper(input: UpdateEngineerInput) {
  return callGraphQL<UpdateEngineerMutation>(updateEngineer, {
    variables: { input },
  }).then(mapEngineerUpdate);
}

export {
  fetchEngineer,
  createEngineerWrapper as createEngineer,
  updateEngineerWrapper as updateEngineer,
};
